import React from 'react';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { Provider } from 'react-redux';
import { LastLocationProvider } from 'react-router-last-location';
import { LogoServicesProvider } from '@wix/branding-client-lib/dist/src/services/LogoServicesProvider';
import DataFetcherContext from './dataFetcherContext';
import { FontUpgrade, WixStyleReactProvider } from 'wix-style-react';

export function createApplication(routerHOC, routes, store, i18n, services = {}, dataFetcher, experiments) {
  return routerHOC(
    <LastLocationProvider>
      <DataFetcherContext.Provider value={dataFetcher}>
        <Provider store={store}>
          <LogoServicesProvider services={services}>
            <ExperimentsProvider options={{ experiments }}>
              <I18nextProvider i18n={i18n}>
                <FontUpgrade active={true}>
                  <WixStyleReactProvider features={{ reducedSpacingAndImprovedLayout: true }}>{routes}</WixStyleReactProvider>
                </FontUpgrade>
              </I18nextProvider>
            </ExperimentsProvider>
          </LogoServicesProvider>
        </Provider>
      </DataFetcherContext.Provider>
    </LastLocationProvider>
  );
}
